import Vue from 'vue'
import Router from 'vue-router'
import test from '@/pages/test'
import chatDetail from '@/pages/chat/chatDetail.vue'
import login from '@/pages/login.vue'
import loginZh from '@/pages/enterpriseLogin/loginZh.vue' // 中化登录页
import error from '@/pages/chat/error.vue'
import findExternallinks from '@/pages/chat/findExternallinks.vue'
import attachmentPreview from '@/pages/chat/attachmentPreview.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/findExternallinks',
      name: 'findExternallinks',
      component: findExternallinks
    },
    {
      path: '/',
      name: 'chatDetail',
      component: chatDetail
    },
    {
      path: '/attachmentPreview',
      name: 'attachmentPreview',
      component: attachmentPreview
    },
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/loginzh',
      name: 'loginzh',
      component: loginZh
    },
    {
      path: '/error',
      name: 'error',
      component: error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js